import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import EditSchedule from '../components/Schedule/EditSchedule';


const Schedule = () => {
  return (
    <Routes>
      <Route path="/edit/:id" element={<EditSchedule />} />
      <Route path="/edit" element={<EditSchedule />} />
    </Routes>
  )
}

export default Schedule;


